import { Component, TemplateRef, computed, input } from '@angular/core';
import { HeadingSelectComponent } from '@app/components/heading-select/heading-select.component';
import { ContentSectionComponent } from '@app/components/content-section/content-section.component';
import { TextComponent } from '@app/components/text/text.component';
import { HeadingType } from '@app/models/global.model';
import { ComponentSharedModule } from '@app/modules/component.shared.module';

@Component({
  selector: 'mobi-media-layout',
  templateUrl: './media-layout.component.html',
  styleUrls: ['./media-layout.component.scss'],
  standalone: true,
  imports: [
    ComponentSharedModule,
    ContentSectionComponent,
    HeadingSelectComponent,
    TextComponent,
  ],
})
export class MediaLayoutComponent {
  readonly id = input('');
  readonly title = input('');
  readonly text = input('');
  readonly position = input('left');
  readonly width = input('normal');
  readonly box = input(false);
  readonly titleSize = input<HeadingType>('h2');
  readonly media = input.required<TemplateRef<any>>();
  readonly content = input<TemplateRef<any> | null>(null);

  hasText = computed(() => !!this.text() || !!this.title());
  hasContent = computed(() => !!this.content());

  layoutWidth = computed(() => {
    switch (this.width()) {
      case 'small':
        return 'sm';
      case 'regular':
        return 'lg';
      default:
        return 'full';
    }
  });
}
